module.exports = __webpack_public_path__ + "static/media/team-4.9121b05c.avif";